// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__17I3L","addWidgetButton":"Header_addWidgetButton__FW7do","dashboardTabs":"Header_dashboardTabs__1qAca","active":"Header_active__uF7Xr"};